import { Component } from '@angular/core';

/**
 * Shown to users on the ISGGPT blocked list (US-36539).
 */
@Component({
  selector: 'isgcore-page-isggpt-restricted',
  templateUrl: './page-isggpt-restricted.component.html',
  styleUrls: ['./page-isggpt-restricted.component.scss'],
  standalone: true
})
export class PageIsgGptRestrictedComponent {
  readonly message = "Access to ISGGPT has been blocked as you haven't completed the 'AI-Assisted Work and Acceptable Use Policy' training. Please complete the training as soon as possible to regain access.";
}
